// Compare at the same tenth-degree precision shown by the station data.
export function temperatureExtreme(station) {
    const values = [station.temperatura, station.tmin, station.tmax];
    if (values.some(v => v == null || v === '' || !Number.isFinite(Number(v)))) return '';
    if (station.has_tmin === false || station.has_tmax === false) return '';
    const [current, min, max] = values.map(v => Math.round(Number(v) * 10));
    if (min >= max) return '';
    return current === max ? 'max' : current === min ? 'min' : '';
}
